import React from "react";
import UserStatus from './UserStatus';
import '../referral.css'; // we'll create this file

export default function Referral() {
  return (
    <div className="page-container">
      <div className="content-wrap">
        {/* Navbar */}
        <section className="navbar-area navbar-one">
          <div className="container">
            <nav className="navbar navbar-expand-lg">
              <a className="navbar-brand" href="/">
                <img width="200" height="70" src={require("../images/logo.png")} alt="Logo" />
              </a>
              <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarOne">
                <span className="toggler-icon"></span>
                <span className="toggler-icon"></span>
                <span className="toggler-icon"></span>
              </button>

              <div className="collapse navbar-collapse sub-menu-bar" id="navbarOne">
                <ul className="navbar-nav m-auto">
                  <li className="nav-item"><a className="page-scroll" href="/">Home</a></li>
                  <li className="nav-item"><a className="page-scroll" href="/pricing">Pricing</a></li>  
                <li className="nav-item">
                  <a className="active page-scroll" href="/referral">Refer and Win</a>
                </li>
                <li className="nav-item"><a className="page-scroll" href="/faq">FAQ</a></li>
                  <li className="nav-item"><a className="page-scroll" href="/contact">Contact Us</a></li>
                </ul>
              </div>

              <div className="navbar-btn">
                <UserStatus />
              </div>
            </nav>
          </div>
        </section>

        {/* Referral Section */}
        <section className="py-5" style={{ backgroundColor: '#f9f9f9ff' }}>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8 col-lg-6">
                <h1 style={{marginTop: '140px', textAlign: 'center'}}>Win Free Months by Referring Friends!</h1>
                <p className="referral-text">
                  Sign up today to get your unique referral link. Share it with your network and earn a 
                  <strong> free month</strong> of paid subscription when 10 friends sign up for any paid plan.
                </p>

                <p className="referral-text-secondary">
                  Don’t miss out — the more friends you refer, the more you earn!
                </p>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <a className="big-referral-button" href="/signup">
                    Create Account & Get Referral Link
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Footer */}
      <section className="footer-area footer-five">
  <div className="container">
    <div className="footer-top-content">
      
      {/* Links Section */}
      <div className="footer-links">
        <ul>
          <li>
            <a href="/terms" target="_blank" rel="noopener noreferrer">
              Terms & Conditions
            </a>
          </li>
          <li>
            <a href="/privacy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
          </li>
        </ul>
      </div>

      {/* Contact Section */}
      <div className="footer-contact">
        <h4>Contact Us:</h4>
        <a href="mailto:support@tradebarta.com">support@tradebarta.com</a>
      </div>

    </div>
  </div>

  {/* Bottom copyright section */}
  <div className="footer-copyright">
    <div className="container">
      <p className="text-center">Copyright © 2025. All Rights Reserved</p>
    </div>
  </div>
</section>
 </div>
  );
}
